import type { Writing } from "./types";

const writing: Writing = {
  slug: "designer-vibecodes-design-engineer",
  title: "Vibecoding Designer vs Design Engineer",
  date: "2026",
  status: "WIP",
  description: "Coming soon",
  placeholder: [],
};

export default writing;
